export default __webpack_public_path__ + "static/media/30.4c3a5934.png";